import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Relatorio } from '../../index';

@Injectable()
export class RelatoriosService {

  private url = environment.backendBaseUrl + '/manager/relatorio';

  constructor(private http: HttpClient) { }

  relatorioCadastroUsuarios(relatorio: Relatorio): Promise<any> {
    return this.http
      .post(`${this.url}/relatorioCadastroUsuarios`, relatorio, { 'responseType': 'blob', observe: 'response' })
      .toPromise()
      .then(response => response)
      .catch(this.handleBlobError);
  }

  relatorioMetricas(relatorio: Relatorio): Promise<any> {
    return this.http
      .post(`${this.url}/relatorioMetricas`, relatorio, { 'responseType': 'blob', observe: 'response' })
      .toPromise()
      .then(response => response)
      .catch(this.handleBlobError);
  }

  relatorioSolicitacoes(relatorio: Relatorio): Promise<any> {
    return this.http
      .post(`${this.url}/relatorioSolicitacoes`, relatorio, { 'responseType': 'blob', observe: 'response' })
      .toPromise()
      .then(response => response)
      .catch(this.handleBlobError);
  }

  relatorioLicencasConsumidas(relatorio: Relatorio): Promise<any> {
    return this.http
      .post(`${this.url}/relatorioLicencasConsumidas`, relatorio, { 'responseType': 'blob', observe: 'response' })
      .toPromise()
      .then(response => response)
      .catch(this.handleBlobError);
  }

  relatorioHistoricoUso(relatorio: Relatorio): Promise<any> {
    return this.http
      .post(`${this.url}/relatorioHistoricoUso`, relatorio, { 'responseType': 'blob', observe: 'response' })
      .toPromise()
      .then(response => response)
      .catch(this.handleBlobError);
  }

  private async handleBlobError(error: any): Promise<any> {
    const message = await error.error.text();

    return Promise.reject(message);
  }
}